import { Stack } from '@mui/material';

import { PageHeader } from '@/components/navigation/PageHeader';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { useClientDetailsGiftingPageQuery } from '@/modules/gifting/hooks/useClientDetailsGiftingPageQuery';
import { ClientDetailsGiftingPage } from '@/pages/ClientDetailsPage/ClientDetailsGiftingPage/ClientDetailsGiftingPage';
import { DownloadGiftingCSVButton } from '@/pages/ClientDetailsPage/ClientDetailsGiftingPage/DownloadGiftingCSVButton/DownloadGiftingCSVButton';
import { ManagePortabilityButton } from '@/pages/ClientDetailsPage/ClientDetailsGiftingPage/ManagePortabilityButton';
import { ClientGiftingAddButton } from '@/pages/ClientPages/ClientGiftingPage/ClientGiftingAddButton';

export function ClientGiftingPage() {
  const householdId = useRequiredParam('householdId');
  const { hasExclusionEvents } = useClientDetailsGiftingPageQuery(householdId);

  return (
    <Stack>
      <PageHeader
        heading="Exemptions"
        action={
          <Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <DownloadGiftingCSVButton
                householdId={householdId}
                disabled={!hasExclusionEvents}
              />

              <ManagePortabilityButton />
              <ClientGiftingAddButton popperVariant="menuBelow" />
            </Stack>
          </Stack>
        }
      />
      <Stack p={2} flex={1}>
        <ClientDetailsGiftingPage />
      </Stack>
    </Stack>
  );
}
